import type { RouteRecordRaw } from 'vue-router'

export const auditLogsRoutes: RouteRecordRaw[] = [
  {
    path: '/compliance/audit-logs',
    name: 'COMPLIANCE_AUDIT_LOGS',
    component: () => import('./AuditLogsPage.vue'),
    meta: { requiresAuth: true },
  },
]
